import { Container, Flex, Text } from '@chakra-ui/react';

import { NumeratedCard } from '@/components/ui/features/publishers/ReasonsSection/components/NumeratedCard';
import { reasonList } from '@/components/ui/features/publishers/ReasonsSection/components/reasonList';

export const ReasonsSection = () => {
  return (
    <Container
      mt={{ base: 6, md: 8, lg: 10 }}
      width="full"
      textAlign="center"
      justifyContent="center"
      alignItems="center"
    >
      <Text
        w="full"
        textAlign="center"
        fontFamily="heading"
        fontWeight="bold"
        fontSize={{ base: '2xl', md: '4xl', lg: '5xl' }}
      >
        <Text
          as="span"
          fontFamily="heading"
          backgroundClip="text"
          bgGradient="linear-gradient(90deg, #E179F1 0%, #BD8AF5 26.56%, #70B5EF 50%, #5BC5DF 74.48%, #52A3B0 98.96%)"
        >
          21 Reasons{' '}
        </Text>
        to Record
        <br />
        Your Conference
      </Text>
      <Text fontSize="xl" mt={{ base: 4, md: 6 }}>
        Transform challenges into opportunities with professional conference recording
      </Text>
      <Flex mt={{ base: 4, md: 6, lg: 8 }} gap={4} justifyContent="center" alignItems="center" flexWrap="wrap">
        {reasonList.map((reason, index) => (
          <NumeratedCard key={reason.label} number={index + 1} label={reason.label} description={reason.description} />
        ))}
      </Flex>
    </Container>
  );
};
